<template>

  <div class="pl-1 fill-height">
    <slot />
  </div>

</template>
